import { EventEmitter, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {

    breadCrumbTitle: string[] = [];

    breadCrumbChangeEvent: EventEmitter<string[]> = new EventEmitter<string[]>();

    constructor(private _router: Router, private _activatedRoute: ActivatedRoute) {
        
        _router.events.pipe(filter((route) => route instanceof NavigationEnd)).subscribe(() => {
            this.breadCrumbTitle = [];
            let activatedChild: ActivatedRoute | null = this._activatedRoute.firstChild ?? null;
    
            while(activatedChild != null) {
                if (!String.isNullOrUndefinedOrWhitespace(activatedChild.snapshot.data['pageTitle'])) {
                    this.breadCrumbTitle.push(activatedChild.snapshot.data['pageTitle'])
                }
                
                activatedChild = activatedChild.firstChild;
            }
            
            this.breadCrumbChangeEvent.emit(this.breadCrumbTitle);
        });


    }

    addBreadcrumb(breadcrumbSection: string) {
        if (!String.isNullOrUndefinedOrWhitespace(breadcrumbSection)) {
            this.breadCrumbTitle.push(breadcrumbSection);
            this.breadCrumbChangeEvent.emit(this.breadCrumbTitle);
        }
    }

    
}